import { useCallback, useSyncExternalStore } from 'react';

/**
 * Suscripción a una media query desde React.
 *
 * Existe para elegir ESTRUCTURA, no estilo: cuando el ancho obliga a cambiar de
 * tabla a tarjetas, ocultar columnas con CSS deja el dato en el DOM pero fuera
 * de la vista. Aquí se decide qué se renderiza, y así la versión angosta puede
 * reordenar la información en vez de recortarla.
 *
 * Para todo lo demás (espaciados, tipografías, grillas) siguen siendo mejores
 * los `@media` en CSS: no re-renderizan.
 */
export function useMediaQuery(query: string): boolean {
  const soportado = typeof window !== 'undefined' && typeof window.matchMedia === 'function';

  const suscribir = useCallback(
    (avisar: () => void) => {
      if (!soportado) return () => {};
      const mq = window.matchMedia(query);
      mq.addEventListener('change', avisar);
      return () => mq.removeEventListener('change', avisar);
    },
    [query, soportado],
  );

  const leer = useCallback(
    () => soportado && window.matchMedia(query).matches,
    [query, soportado],
  );

  // El snapshot del servidor es `false`: sin ventana no hay ancho que medir, y
  // la variante angosta es la que degrada mejor.
  return useSyncExternalStore(suscribir, leer, () => false);
}
